import styled from '@emotion/styled';

const sizeMap = {
  sm: { title: 32, subtitle: 14 },
  header: { title: 36, subtitle: 15 },
  md: { title: 42, subtitle: 18 },
  lg: { title: 54, subtitle: 24 },
  xl: { title: 60, subtitle: 24 },
};

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $align }) => ($align === 'start' ? 'flex-start' : 'center')};
  width: ${({ $align }) => ($align === 'start' ? 'auto' : '85%')};
  max-width: ${({ $align }) => ($align === 'start' ? 'none' : '360px')};
  margin: ${({ $align }) => ($align === 'start' ? '0' : '0 auto 8px')};
`;

export const LogoTitleRow = styled.h1`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
`;

export const LogoTitlePrimary = styled.span`
  font-family: 'Unkempt', cursive;
  font-weight: 700;
  font-size: ${({ $size }) => sizeMap[$size || 'md'].title}px;
  line-height: 1.1;
  color: ${({ theme }) => theme.palette.secondary.main};
`;

export const LogoTitleAccent = styled.span`
  font-family: 'Unkempt', cursive;
  font-weight: 700;
  font-size: ${({ $size }) => sizeMap[$size || 'md'].title}px;
  line-height: 1.1;
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const LogoSubtitle = styled.span`
  font-family: 'Unkempt', cursive;
  font-weight: 400;
  font-size: ${({ $size }) => sizeMap[$size || 'md'].subtitle}px;
  line-height: 1.2;
  color: ${({ theme }) => theme.palette.primary.main};
  align-self: ${({ $align }) => ($align === 'start' ? 'flex-start' : 'flex-end')};
  margin-top: 0;
`;
